import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const EmployeeAvailabilityView = lazy(() =>
  import("@/components/employee/EmployeeAvailabilityView").then((m) => ({
    default: m.EmployeeAvailabilityView,
  })),
);

export const Route = createFileRoute("/_authenticated/employee/availability")({
  head: () => ({ meta: [{ title: "Availability: Staff" }] }),
  component: AvailabilityPage,
});

function AvailabilityPage() {
  return (
    <Suspense fallback={<div className="text-sm text-foreground/60">Loading calendar…</div>}>
      <EmployeeAvailabilityView />
    </Suspense>
  );
}
